<div class="container p-2">
  
    <div class="mat-dialog-content">
    <p>Are you sure you want to reject ?</p>
  </div>

  <div class="row">
    <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <form [formGroup]="reasonForm">
        <mat-label for="reason">Reason:</mat-label>
        <mat-form-field class="example-full-width" appearance="fill">
          <textarea
            name="reason"
            id="reason"
            matInput
            formControlName="driver_reason"
          ></textarea>
        </mat-form-field>
      </form>
    </div>
  </div>
  <div class="d-flex justify-content-around align-items-center">
    <button class="ex2" mat-raised-button (click)="activityReason()">
      Yes
    </button>
    <button class="ex1" matButton (click)="close()">No</button>
  </div>
</div>
